import { render } from "./CoreBookmarkLoginDialog.vue?vue&type=template&id=241389c5&scoped=true"
import script from "./CoreBookmarkLoginDialog.vue?vue&type=script&lang=js"
export * from "./CoreBookmarkLoginDialog.vue?vue&type=script&lang=js"

import "./CoreBookmarkLoginDialog.vue?vue&type=style&index=0&id=241389c5&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-241389c5"]])

export default __exports__